module.exports = "/_next/static/images/fp-logo-dd5fbbe1bfd57f53bfd99aed73a21161.svg";